<template>
  <div class="item-inner-container grid-x grid-margin-x margin-bottom-xs">
    <div class="cell small-12 medium-4 align-center text-center">
      <div class="grid-x">
        <div class="cell small-12 medium-11 small-padding-right-xxl small-padding-left-xxl medium-padding-right-xs medium-padding-left-xs">
          <p class="margin-bottom-s">
            <span
              class="lh-item-image"
              :class="ICON1_IMAGE"
            ></span>
          </p>
          <p
            class="margin-bottom-xxs"
            :class="ICON1_TITLE_CLASS"
          >
            {{ ICON1_TITLE }}
          </p>
          <p>{{ ICON1_CONTENT1 }}</p>
          <p v-if="ICON1_EXCLUSION_LINK">
            <a
              :href="ICON1_EXCLUSION_LINK"
              target="_blank"
              >{{ ICON1_EXCLUSION_LINK_TEXT }}</a
            >
          </p>
        </div>
        <div class="cell small-12 medium-1 small-margin-top-s small-margin-bottom-s medium-margin-top-z medium-margin-bottom-z">
          <span class="swipe-arrow-right margin-top-xxs"></span>
          <span class="swipe-arrow-down"></span>
        </div>
      </div>
    </div>
    <div class="cell small-12 medium-4 align-center text-center">
      <div class="grid-x">
        <div class="cell small-12 medium-11 small-padding-right-xxl small-padding-left-xxl medium-padding-right-xs medium-padding-left-xs">
          <p class="margin-bottom-s">
            <span
              class="lh-item-image"
              :class="ICON2_IMAGE"
            ></span>
          </p>
          <p
            class="margin-bottom-xxs"
            :class="ICON2_TITLE_CLASS"
          >
            {{ ICON2_TITLE }}
          </p>
          <p>{{ ICON2_CONTENT1 }}</p>
        </div>
        <div class="cell small-12 medium-1 small-margin-top-s small-margin-bottom-s medium-margin-top-z medium-margin-bottom-z">
          <span class="swipe-arrow-right margin-top-xxs"></span>
          <span class="swipe-arrow-down"></span>
        </div>
      </div>
    </div>
    <div class="cell small-12 medium-4 align-center text-center">
      <div class="grid-x">
        <div class="cell small-12 medium-11 small-padding-right-xxl small-padding-left-xxl medium-padding-right-xs medium-padding-left-xs">
          <p class="margin-bottom-s">
            <span
              class="lh-item-image"
              :class="ICON3_IMAGE"
            ></span>
          </p>
          <p
            class="margin-bottom-xxs"
            :class="ICON3_TITLE_CLASS"
          >
            {{ ICON3_TITLE }}
          </p>
          <p>{{ ICON3_CONTENT1 }}</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { HOW_IT_WORKS } from '../../config';

const {
  ICON1_IMAGE,
  ICON1_TITLE,
  ICON1_CONTENT1,
  ICON1_TITLE_CLASS,
  ICON1_EXCLUSION_LINK_TEXT,
  ICON1_EXCLUSION_LINK,
  ICON2_IMAGE,
  ICON2_TITLE,
  ICON2_CONTENT1,
  ICON2_TITLE_CLASS,
  ICON3_IMAGE,
  ICON3_TITLE,
  ICON3_CONTENT1,
  ICON3_TITLE_CLASS,
} = HOW_IT_WORKS;
</script>



<style lang="scss" scoped>
@import '~@core/csg/src/scss/encodedIcons/bcom/_swipe-arrow-right.scss';
@import '~@core/csg/src/scss/encodedIcons/bcom/_swipe-arrow-down.scss';
@import '~@core/csg/src/scss/encodedIcons/bcom/_exclusive-storewide-offers.scss';
@import '~@core/csg/src/scss/encodedIcons/bcom/_autopay.scss';
@import '~@core/csg/src/scss/encodedIcons/bcom/_bag-small-logo-black.scss';


.item-inner-container {
  .swipe-arrow-right {
    display: block;
    margin: 0 auto;
  }
  .swipe-arrow-down {
    display: none;
  }
  @include breakpoint(small only) {
    .swipe-arrow-down {
      display: block;
      margin: 0 auto;
    }
    .swipe-arrow-right {
      display: none;
    }
  }
  span.lh-item-image {
    height: rem-calc(48);
    vertical-align: middle;
    transform: scale(2, 2);
    transform-origin: top;
  }
}
</style>